import { applyMiddleware, createStore, compose } from 'redux';
import logger from 'redux-logger';
import thunk from 'redux-thunk';

import reducer from './indexReducer';
import sessionResetMiddleware from './sessionResetMiddleware';
import { attachBackendOverrideStore } from '../utils/backendOverride';
import {
  conversationTelemetryReporter,
  createConversationTelemetryMiddleware,
} from '../utils/conversationTelemetryClient';
import { createSafeReduxEnhancer } from '../observability/reduxSentry';

let store = null;

// NO usar `Sentry.createReduxEnhancer({})` a pelo: con las opciones por
// defecto adjunta el estado COMPLETO de Redux a cada evento (contexto,
// adjunto `redux_state.json` y breadcrumb por acción), lo que exporta a
// Sentry la bandeja del asesor —teléfonos, nombres y texto de los mensajes
// de clientes finales—. `createSafeReduxEnhancer` manda un resumen sin PII.
// Ver `src/observability/reduxSentry.js`.
const sentryReduxEnhancer = createSafeReduxEnhancer();

// Telemetría de aislamiento de conversaciones. Va como middleware y no en cada
// punto de inserción porque son siete los caminos por los que una conversación
// entra al estado, y dos de ellos no tienen hoy ninguna verificación: el
// deep-link por chatId y el insert de markAsUnread. Nunca lanza: si algo falla
// dentro, se traga el error y la acción sigue su curso.
const conversationTelemetry = createConversationTelemetryMiddleware(
  conversationTelemetryReporter,
);

if (process.env.REACT_APP_ENV === 'PRODUCTION') {
  store = createStore(
    reducer,
    {},
    compose(applyMiddleware(thunk, sessionResetMiddleware, conversationTelemetry), sentryReduxEnhancer)
  );
}

if (process.env.REACT_APP_ENV === 'DEVELOPMENT') {
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  store = createStore(
    reducer,
    {},
    composeEnhancers(
      applyMiddleware(thunk, sessionResetMiddleware, logger, conversationTelemetry),
      sentryReduxEnhancer,
    )
  );
}

// The A/B backend routing reads companyId from this store at request time
// (attached here instead of imported there to avoid an import cycle).
attachBackendOverrideStore(store);

// El acumulador se vacía al ocultarse la pestaña, que es cuando un agente cambia
// de ventana o cierra: sin esto, lo que vio en los últimos segundos se perdería.
// `visibilitychange` es el evento fiable para eso; `unload` no se dispara en
// móviles. El envío usa fetch con keepalive, así que sobrevive a la navegación.
if (typeof document !== 'undefined' && document.addEventListener) {
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') {
      conversationTelemetryReporter.flush();
    }
  });
}

export default store;
